import React from "react"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { theme } from "../../theme/theme"
import { MenuM } from "./MenuM"

export const Menu3Point = ({
    menuItems,
    position,
    style,
    color = theme.colors.primary,
    optionStyle,
    icon = "ellipsis-v",
    customButtonComponent = null,
    iconSize = 20,
    useFA6 = false,
}) => {
    const renderButton = () => (
        <FontAwesome5
            style={{ paddingHorizontal: 10, paddingVertical: 5 }}
            name={icon}
            size={iconSize}
            color={color}
        />
    )

    return (
        <MenuM
            buttonComponent={customButtonComponent ?? renderButton()}
            items={menuItems}
            position={position}
            style={style}
            optionStyle={optionStyle}
            useFA6={useFA6}
        />
    )
}
